export const unInitializedErrorString = 'Please initialize logger before calling';
